export const phoneType = {
  type: 'phone',
  parser: (value) => {
    if (!value) return null;
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length < 10) throw Error('Número de telefone inválido');
    return cleaned;
  },
  parseErrorMessage: 'Formato de telefone inválido. Use o formato (XX) XXXXX-XXXX',
};
